module.exports = __webpack_public_path__ + "static/media/tippr.12886492.png";